var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"niste-clan"},[_c('div',[_vm._v(_vm._s(_vm.$t("not_part.case_text")))]),_c('router-link',{attrs:{"to":"/cases"}},[_vm._v(_vm._s(_vm.$t("not_part.go_back")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }